(function ($, Cobalt, undefined) {
    Cobalt.TimerFunction = function (name, callback, $container) {
        this.functionName = name;
        this.callback = callback;
        this.lastActivity = null;
        this.pollRate = null;
        this.lastDate = new Date().getTime();

        var self = this;
        var action = function (e) {
            self.onAction();
        };
        $container.mousemove(action);
        $container.keydown(action);
        $container.ready(action);
    };

    Cobalt.TimerFunction.prototype.run = function () {
        this.lastDate = new Date().getTime();
        this.callback();
        this.calculateThrottle();
    };

    Cobalt.TimerFunction.prototype.onAction = function () {
        this.lastActivity = new Date().getTime();
        this.pollRate = Cobalt.PollingThrottle.fastPollRate * (Math.random() * 0.4 + 0.8);
    };

    Cobalt.TimerFunction.prototype.calculateThrottle = function () {
        if (this.lastActivity === null) {
            this.pollRate = Cobalt.PollingThrottle.slowPollRate * (Math.random() * 0.4 + 0.8);
            return;
        }

        var difference = new Date().getTime() - this.lastActivity;

        var previousPollRate = this.pollRate;
        if (difference > Cobalt.PollingThrottle.slowestActivityThreshold) {
            this.pollRate = null;
        } else if (difference <= Cobalt.PollingThrottle.fastActivityThreshold) {
            this.pollRate = Cobalt.PollingThrottle.fastPollRate;
        } else if (difference <= Cobalt.PollingThrottle.midActivityThreshold) {
            var percentage = 1 - (Cobalt.PollingThrottle.midActivityThreshold - difference) / (Cobalt.PollingThrottle.midActivityThreshold - Cobalt.PollingThrottle.fastActivityThreshold);
            this.pollRate = Cobalt.PollingThrottle.fastPollRate +
                           (percentage
                          * (Cobalt.PollingThrottle.midPollRate - Cobalt.PollingThrottle.fastPollRate));
        } else if (difference <= Cobalt.PollingThrottle.slowActivityThreshold) {
            var percentage = 1 - (Cobalt.PollingThrottle.slowActivityThreshold - difference) / (Cobalt.PollingThrottle.slowActivityThreshold - Cobalt.PollingThrottle.midActivityThreshold);
            this.pollRate = Cobalt.PollingThrottle.midPollRate +
                           (percentage
                          * (Cobalt.PollingThrottle.slowPollRate - Cobalt.PollingThrottle.midPollRate));
        } else {
            var percentage = 1 - (Cobalt.PollingThrottle.slowestActivityThreshold - difference) / (Cobalt.PollingThrottle.slowestActivityThreshold - Cobalt.PollingThrottle.slowActivityThreshold);
            this.pollRate = Cobalt.PollingThrottle.slowPollRate +
                           (percentage
                          * (Cobalt.PollingThrottle.slowestPollRate - Cobalt.PollingThrottle.slowPollRate));
        }

        if (this.pollRate !== null) {
            this.pollRate = this.pollRate * (Math.random() * 0.4 + 0.8);
        }
    };

    Cobalt.PollingThrottle = {
        slowestActivityThreshold: 120000,
        slowActivityThreshold: 30000,
        midActivityThreshold: 10000,
        fastActivityThreshold: 2000,
        fastPollRate: 2000,
        midPollRate: 10000,
        slowPollRate: 30000,
        slowestPollRate: 120000,
        isStopped: false,
        timer: null,
        timerFunctions: new Array(),
        isInitialize: false,
        initialize: function () {
            Cobalt.PollingThrottle.runTimerFunctions();
            Cobalt.PollingThrottle.isInitialized = true;
        },
        clearTimer: function () {
            clearTimeout(Cobalt.PollingThrottle.timer);
        },
        registerTimerFunction: function (name, callback, $container) {
            if (!Cobalt.PollingThrottle.isInitialized) {
                Cobalt.PollingThrottle.initialize();
            }
            if (typeof callback === "function") {
                var timerFunction = new Cobalt.TimerFunction(name, callback, $container || $(window));
                Cobalt.PollingThrottle.timerFunctions.push(timerFunction);
            }
        },
        removeTimerFunction: function (name) {
            var index = -1;
            for (var i = 0; i < Cobalt.PollingThrottle.timerFunctions.length; i++) {
                if (name == Cobalt.PollingThrottle.timerFunctions[i].functionName) {
                    index = i;
                    break;
                }
            }
            if (index >= 0) {
                Cobalt.PollingThrottle.timerFunctions.splice(index, 1);
            }
        },
        runTimerFunctions: function () {
            if (Cobalt.PollingThrottle.timerFunctions.length > 0) {
                $.each(Cobalt.PollingThrottle.timerFunctions, function (i, val) {
                    if (val.pollRate !== null) {
                        var nextDate = val.lastDate + val.pollRate;
                        if (nextDate < new Date().getTime()) {
                            val.run();
                        }
                    }
                });
            }
            Cobalt.PollingThrottle.timer = setTimeout(Cobalt.PollingThrottle.runTimerFunctions, 100);
        },
        focusWindow: function () {
            // no need to do anything
        },
        blurWindow: function () {
            $.each(Cobalt.PollingThrottle.timerFunctions, function (i, val) {
                val.lastActivity = null;
                val.pollRate = null;
            });
        }
    };

    $(window).focus(function () {
        Cobalt.PollingThrottle.focusWindow();
    }).blur(function () {
        Cobalt.PollingThrottle.blurWindow();
    });
    
})(jQuery, Cobalt);


// WEBPACK FOOTER //
// ./content/js/Cobalt/Cobalt.PollingThrottle.js